import { createApiAction } from '@saucelabs/sl-util-redux';

import { retrieveInvoices } from './api';
import { FETCH_INVOICES } from './types';

export const fetchInvoicesAction = createApiAction(
  FETCH_INVOICES,
  () => retrieveInvoices(),
);
